import { QueryClient } from "@tanstack/react-query";

import { AUTH_TOKEN_STORAGE_KEY } from "~/helpers/consts";

export const disableAllRefetch = {
  refetchInterval: false,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

// Query meta for requests where a 403 is an expected answer (e.g. telling a
// member from an admin): SubscriptionSync doesn't take it for lost access.
export const EXPECTS_FORBIDDEN_META_KEY = "expectsForbidden";
export const EXPECTS_FORBIDDEN_META = {
  [EXPECTS_FORBIDDEN_META_KEY]: true,
} as const;

export const retryOnNetworkError = (failureCount: number, error: unknown) => {
  let status = 0;

  if (isResponse(error)) {
    status = error.status;
  }

  if (isErrorWithResponse(error)) {
    status = error.response.status;
  }

  switch (status) {
    case 0:
      // No response status, likely a network error
      return failureCount < 3;
    case 401:
      // TODO: this is dirty and must be replaced
      localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
      window.location.href = "/login";

      return false;
    default:
      return false;
  }
};

const isResponse = (error: unknown): error is Response => {
  return typeof error === "object" && error !== null && "status" in error;
};

type ErrorWithResponse = Error & {
  response: { status: number };
};

const isErrorWithResponse = (error: unknown): error is ErrorWithResponse => {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof error.response === "object" &&
    error.response !== null &&
    "status" in error.response
  );
};

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      ...disableAllRefetch,
      retry: retryOnNetworkError,
    },
  },
});
